// Load Swiper CSS
const swiperCSS = document.createElement('link');
swiperCSS.rel = 'stylesheet';
swiperCSS.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
document.head.appendChild(swiperCSS);

// Load Swiper JS and call function after it loads
const swiperScript = document.createElement('script');
swiperScript.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
swiperScript.onload = function() {
    // Your function to call after Swiper loads
    
        initializeSwiper();
    
};
document.head.appendChild(swiperScript);

// Function to call after Swiper script loads
function initializeSwiper() {
    // Check if Swiper is available
    if (typeof Swiper !== 'undefined') {
        console.log('Swiper loaded successfully!');

        // Check if sunscreen selector elements exist before initializing
        if (document.querySelector('.sunscreen-swiper') && 
            document.getElementById('progress-handle') && 
            document.getElementById('progress-bar')) {
            sunscreenSelectorSwiper();
        }

        // Check if beautiful wall elements exist before initializing
        if (document.querySelector('.wall-wrapper') && 
            document.querySelectorAll('.beautiful-wall-card').length > 0) {
            beautifulWallSwiper();
        }

        // Check if mini PDP elements exist before initializing
        if (document.querySelector('.mini-pdp-wrapper') && 
            document.querySelector('.mini-pdp-add-to-cart')) {
            miniPdpSwiper();
        }

        
        
        // Initialize your Swiper instances here
        // Example:
        // const swiper = new Swiper('.swiper', {
        //     // Swiper options
        // });
        
        // Add your custom initialization code here
    } else {
        console.error('Swiper failed to load');
    }
}

function beautifulWallSwiper() {
    const slides = document.querySelectorAll('.beautiful-wall-card');
    const wrapper = document.querySelector('#beautiful-wall .swiper-wrapper');
    
    // Safety check - if required elements don't exist, exit early
    if (!slides.length || !wrapper) {
        console.log('Beautiful wall elements not found, skipping initialization');
        return;
    }
    
    let middleIndex = Math.floor(slides.length / 2);

    const swiper = new Swiper('.wall-wrapper', {
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      loop: false,
      spaceBetween: 15,
      speed: 300,
      touchRatio: 1.5,
      touchReleaseOnEdges: true,
      longSwipesRatio: 0.2,
      navigation: false,
      cssMode: true,
      cardsEffect: {
        perSlideOffset: 10,
        perSlideRotate: 0,
        slideShadows: false,
        touchReleaseOnSet: true,
        duration: 300,
      },
      on: {
        init: function () {
          const screenWidth = window.innerWidth;
          wrapper.style.height = screenWidth < 390 ? '450px' : '475px';    
        },
        slideChange: function () {
          window?.trackMixpanelEvent('Scrolled Most Beautiful Wall', {
            from: 'most-beautiful-wall',
          });
        },
      },
    });

    function snapToNearest(value) {
      if (value <= 25) return 0;
      if (value <= 75) return 50;
      return 100;
    }


    let isDragging = false;
    let startX, startLeft;

    function handleStart(e) {
      e.preventDefault();
      isDragging = true;

      startX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      startLeft = parseFloat(progressHandle.style.left);

      document.addEventListener('touchmove', handleMove, { passive: false });
      document.addEventListener('mousemove', handleMove);
      document.addEventListener('touchend', stopDragging);
      document.addEventListener('mouseup', stopDragging);
    }

    function handleMove(e) {
      if (!isDragging) return;
      e.preventDefault();

      const clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      const barRect = progressBar.getBoundingClientRect();

      let newLeft = ((clientX - barRect.left) / barRect.width) * 100;
      newLeft = Math.max(0, Math.min(100, newLeft));

      const snappedValue = snapToNearest(newLeft);

      swiper.params.speed = 0;
      const totalSlides = swiper.slides.length - (swiper.loopFillGroup ? swiper.loopFillGroup.size * 2 : 0);
      const targetSlide = Math.round((snappedValue / 100) * (totalSlides - 1));

      swiper.slideTo(targetSlide, 0, false);
    }

    function stopDragging(e) {
      isDragging = false;
      document.removeEventListener('touchmove', handleMove);
      document.removeEventListener('mousemove', handleMove);
      document.removeEventListener('touchend', stopDragging);
      document.removeEventListener('mouseup', stopDragging);

      // Restore Swiper transitions
      setTimeout(() => {
        swiper.params.speed = 300;
      }, 50); // Small delay to prevent immediate transition conflicts
    }

}

function sunscreenSelectorSwiper() {
    const slides = document.querySelectorAll(".sunscreen-card"); 
    const progressHandle = document.getElementById("progress-handle");
    const progressBar = document.getElementById("progress-bar");
    const wrapper = document.querySelector('#sunscreen-selector .swiper-wrapper');
    
    // Safety check - if required elements don't exist, exit early
    if (!slides.length || !progressHandle || !progressBar || !wrapper) {
        console.log('Sunscreen selector elements not found, skipping initialization');
        return;
    }
    
    let middleIndex = Math.floor(slides.length / 2);
    const labels = {
      dry: document.getElementById("label-dry"),
      normal: document.getElementById("label-normal"),
      oily: document.getElementById("label-oily")
    };
  
    const positions = {
      dry: 0,
      normal: 50,
      oily: 100
    };
  
    const swiper = new Swiper(".sunscreen-swiper", {
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: "auto",
      loop:false,
      spaceBetween: 15,
      speed: 300,
      touchRatio: 1.5,
      touchReleaseOnEdges: true,
      longSwipesRatio: 0.2,
      navigation: false,
      cssMode: true,
      initialSlide: 1,
      cardsEffect: {
        perSlideOffset: 10,
        perSlideRotate: 0,
        slideShadows: false,
        touchReleaseOnSet: true,
        duration: 300 
      },
      on: {
        init: function () {
          const screenWidth = window.innerWidth;
          wrapper.style.height = screenWidth < 390 ? '450px' : '475px';
          updateButtons(this);
          updateProgress(this);
        },
        slideChange: function () {
          updateButtons(this);
          updateProgress(this);
        }
      }
    });
  
    function updateButtons(swiperInstance) {
        document.querySelectorAll(".sunscreen-card .add-to-cart-btn").forEach(button => {
            button.style.display = "none";
        });
    
        let activeSlide = swiperInstance.slides[swiperInstance.activeIndex]; // Get correct active slide
    
        if (activeSlide) {
            let button = activeSlide.querySelector(".add-to-cart-btn");
            if (button) {
                button.style.display = "block"; // Show button only on the active slide
            }
        }
    }
  
    function snapToNearest(value) {
      if (value <= 25) return 0;
      if (value <= 75) return 50;
      return 100;
    }
  
    function updateLabels(position) {
      Object.values(labels).forEach(label => label.classList.remove("active"));
      if (position === 0) labels.dry.classList.add("active");
      else if (position === 50) labels.normal.classList.add("active");
      else if (position === 100) labels.oily.classList.add("active");
      document.querySelectorAll(".progress-dot").forEach(dot => {
        dot.classList.remove("active");
      });
    
      if (position === 0) {
        document.getElementById("dot-dry").classList.add("active");
      } else if (position === 50) {
        document.getElementById("dot-normal").classList.add("active");
      } else if (position === 100) {
        document.getElementById("dot-oily").classList.add("active");
      }
    }
  
    function updateProgress(swiperInstance) {
      const realIndex = swiperInstance.realIndex; // Use realIndex instead of activeIndex
      const slidesLength = swiperInstance.slides.length - 
                          (swiperInstance.loopFillGroup ? 
                           swiperInstance.loopFillGroup.size * 2 : 0);
      
      const progressValue = (realIndex / (slidesLength - 1)) * 100;
      const snappedValue = snapToNearest(progressValue);
      
      progressHandle.style.left = `${snappedValue}%`;
      updateLabels(snappedValue);
    }
  
    Object.keys(labels).forEach(key => {
      labels[key].addEventListener("click", function () {
        const snappedValue = positions[key];
  
        progressHandle.style.left = `${snappedValue}%`;
        updateLabels(snappedValue);
  
        swiper.params.speed = 0;
        const totalSlides = swiper.slides.length;
        const targetSlide = Math.round((snappedValue / 100) * (totalSlides - 1));
  
        swiper.slideTo(targetSlide, 0, false);
        
        setTimeout(() => {
          swiper.params.speed = 300;
        }, 50);
      });
    });
    
    let isDragging = false;
    let startX, startLeft;
  
    function handleStart(e) {
      e.preventDefault();
      isDragging = true;
      
      startX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      startLeft = parseFloat(progressHandle.style.left);
      
      document.addEventListener("touchmove", handleMove, { passive: false });
      document.addEventListener("mousemove", handleMove);
      document.addEventListener("touchend", stopDragging);
      document.addEventListener("mouseup", stopDragging);
    }
  
     function handleMove(e) {
        if (!isDragging) return;
        e.preventDefault();
        
        const clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
        const barRect = progressBar.getBoundingClientRect();
        
        let newLeft = ((clientX - barRect.left) / barRect.width) * 100;
        newLeft = Math.max(0, Math.min(100, newLeft));
        
        const snappedValue = snapToNearest(newLeft);
        progressHandle.style.left = `${snappedValue}%`;
        
        swiper.params.speed = 0;
        const totalSlides = swiper.slides.length - 
                           (swiper.loopFillGroup ? 
                            swiper.loopFillGroup.size * 2 : 0);
        const targetSlide = Math.round((snappedValue / 100) * (totalSlides - 1));
    
        swiper.slideTo(targetSlide, 0, false);
        updateLabels(snappedValue);
      }
    
      function stopDragging(e) {
        isDragging = false;
        document.removeEventListener("touchmove", handleMove);
        document.removeEventListener("mousemove", handleMove);
        document.removeEventListener("touchend", stopDragging);
        document.removeEventListener("mouseup", stopDragging);
        
        // Restore Swiper transitions
        setTimeout(() => {
          swiper.params.speed = 300;
        }, 50); // Small delay to prevent immediate transition conflicts
      }
   
      progressBar.addEventListener("click", function (e) {
        const rect = progressBar.getBoundingClientRect();
        const clickPosition = ((e.clientX - rect.left) / rect.width) * 100;
        const snappedValue = snapToNearest(clickPosition);
        
        progressHandle.style.left = `${snappedValue}%`;
        
        swiper.params.speed = 0;
        const totalSlides = swiper.slides.length - 
                           (swiper.loopFillGroup ? 
                            swiper.loopFillGroup.size * 2 : 0);
        const targetSlide = Math.round((snappedValue / 100) * (totalSlides - 1));
        
        swiper.slideTo(targetSlide, 0, false);
        updateLabels(snappedValue);
      
        setTimeout(() => {
          swiper.params.speed = 300;
        }, 50);
      });
  
    progressHandle.addEventListener("mousedown", handleStart);
    progressHandle.addEventListener("touchstart", handleStart);
  
    // Initialize
    swiper.on("transitionStart", function() {
      updateProgress(this); // Pass Swiper instance
    });
}

function miniPdpSwiper() {
    const atcPrice = document.querySelector('.mini-pdp-add-to-cart');
    const miniPdpWrapper = document.querySelector('.mini-pdp-wrapper');
    
    // Safety check - if required elements don't exist, exit early
    if (!atcPrice || !miniPdpWrapper) {
        console.log('Mini PDP elements not found, skipping initialization');
        return;
    }
    
    let priceText = atcPrice.getAttribute('data-variant-price');
    

    var swiper = new Swiper('.mini-pdp-wrapper', {
      slidesPerView: 1.35,
      pagination: {
        el: '.mini-pdp-slider-dots-wrapper',
        clickable: true,
      },
      spaceBetween:-0.5,
      breakpoints: {
        500: { slidesPerView: 1.75 },
        1150: { slidesPerView: 1.4 },
      },
      on: {
        slideChange: function () {
          const currentIndex = swiper.activeIndex;
          const totalSlides = swiper.slides.length;
          const buttonText = document.getElementById('miniPdpButtonText');

          if (currentIndex === totalSlides - 1) {
            buttonText.innerHTML = `Add to cart at just ₹ ${priceText/100} `;
          } else {
            buttonText.innerHTML = `Add to cart`;
          }
          window.trackMixpanelEvent('Mini PDP Scrolled', {
            from: 'Mini PDP widget',
          });
          // You can fire any custom code here
        },
      },
    });
  
}

